export enum WebChatThemeMode {
	Auto,
    Dark,
    Light
}
